import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import config from '../config';

const Login = () => {
  const { signIn, loading, isInitialized } = useAuth();

  const handleSignIn = () => {
    if (config.GOOGLE_CLIENT_ID === 'your-google-client-id-here') {
      alert('Please configure your Google Client ID in the environment variables or config file.');
      return;
    }
    signIn();
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingCard}>
          <div style={styles.spinner}></div>
          <p>Loading authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.loginCard}>
        <div style={styles.header}>
          <h1 style={styles.title}>🔍 Candidate Search Portal</h1>
          <p style={styles.subtitle}>Access restricted to @xpheno.com accounts</p>
        </div>
        
        <div style={styles.loginSection}>
          <h2 style={styles.loginTitle}>Sign In Required</h2>
          <p style={styles.loginText}>
            Please sign in with your @xpheno.com Google account to access the candidate search portal.
          </p>
          
          <button
            onClick={handleSignIn}
            disabled={!isInitialized}
            style={{
              ...styles.signInButton,
              ...(isInitialized ? {} : styles.disabledButton)
            }}
          >
            <svg style={styles.googleIcon} viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {isInitialized ? 'Sign in with Google' : 'Initializing...'}
          </button>
          
          {config.GOOGLE_CLIENT_ID === 'your-google-client-id-here' && (
            <div style={styles.warningBox}>
              <p style={styles.warningText}>
                ⚠️ Google Client ID not configured. Please set up your Google OAuth credentials.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px'
  },
  loadingCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '40px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '300px',
    width: '100%'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #007bff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 20px'
  },
  loginCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '40px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    maxWidth: '500px',
    width: '100%'
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px'
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 10px 0'
  },
  subtitle: {
    color: '#666',
    margin: 0,
    fontSize: '1rem'
  },
  loginSection: {
    textAlign: 'center'
  },
  loginTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#333',
    marginBottom: '15px'
  },
  loginText: {
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '30px'
  },
  signInButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    background: 'white',
    border: '2px solid #dadce0',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '500',
    color: '#3c4043',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    width: '100%',
    maxWidth: '280px',
    margin: '0 auto'
  },
  disabledButton: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  googleIcon: {
    width: '20px',
    height: '20px'
  },
  warningBox: {
    background: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '8px',
    padding: '15px',
    marginTop: '20px'
  },
  warningText: {
    color: '#856404',
    margin: 0,
    fontSize: '14px'
  }
};

// Add CSS animation for spinner
const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Inject the keyframes into the document
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = spinKeyframes;
  document.head.appendChild(style);
}

export default Login; 